<template>
    <v-virtual-scroll 
    :items="items" 
    :max-height="height" 
    :class="'timelineStyles '+ classHiddenScroll" 
    v-click-outside="{
      handler: onClickOutside
    }"
    @click="isactiveClick"> 
        <template v-slot:default="{ item }">
            <v-sheet :width="width" color='bgtl' class="ma-2 timelineStyles">
                <p class="ml-3 mt-2">
                    <v-chip vlass="pl-3" :color="item.status.toUpperCase() === 'ALERTA' ? COLOR.red :  COLOR.yellow" variant="flat">
                        {{ item.status.toUpperCase() === 'ALERTA' ? t('labels.alert') : t('labels.alarm')  }}
                    </v-chip>
                    <span v-if="isRecurrent" class="ml-4"> {{ item.fecha }}</span>
                </p>
                <div v-if="isRecurrent">
                    <p class="textDashboard mt-4 ml-3"> <span> {{ t('labels.message') }}: </span> </p>
                    <p class="textDashboard mt-2 ml-3 mb-3"> <span> {{ getMessage(item.causa, item.ip, item.detalle, item.recurrencia??0, item.status, item.name, item.tipo, item.subtipo) }} </span> </p> 
                </div>
                <div v-else>
                    <p class="textDashboard mt-4 ml-3"> <span> {{ item.name }} - {{ item.ip }} - {{ item.fecha }}</span> </p> 
                    <p class="textDashboard mt-4 ml-3"> <span> {{ t('labels.cause') }}: {{ item.causa }} </span> </p> 
                    <p class="textDashboard ml-3 mb-3"> <span> {{ t('labels.detail') }}: {{ getDetalle(item.detalle) }} </span> </p> 
                </div>
            </v-sheet>
        </template>
    </v-virtual-scroll>    
</template>

<script setup lang="ts">
import { ref, Ref } from 'vue';

/********************************
 ********** INTERFACES **********
 *******************************/
import { ALARMTYPE } from '@/interfaces/SmartLink/KPI';

/********************************
 ********** CONSTANTES **********
 *******************************/
import { COLOR } from '@/constants/colors';

/********************************
 ************ I18N **************
 *******************************/
import { useI18n } from 'vue-i18n';
const { t } = useI18n()

const props = defineProps({
    arrayItems  : { type:Array<ALARMTYPE>, required: true },
    width       : { type: Number, default: 300 },
    height      : { type: Number, default: 200 },
    isRecurrent : { type: Boolean, default: false}
})

const items:Ref<ALARMTYPE[]> = ref(props.arrayItems);

/**
 * Genera el mensaje que se mostrará en el componente de alarmas recurrentes
 * @param causa 
 * @param ip 
 * @param detalle 
 * @param recurrencia 
 * @param status 
 * @param name 
 * @param tipo 
 * @param subtipo 
 */
const getMessage = (causa:string, ip:string, detalle:string, recurrencia: number, status:string, name:string, tipo:string, subtipo:string) => {
    let finalDetalle = JSON.parse(detalle)
    let messageFinal = `
    Se ha detectado una ${status} recurrente en el equipo ${ip} - ${name} [ ${subtipo} - ${tipo} ]  ${causa}: "Latencia: ${finalDetalle.latencia}". Ha ocurrido ${recurrencia} veces.`;

    return messageFinal
}

/**
 * Genera el mensaje que se mostrará el componentes de Alertas/Alarmas, bajo el IEO
 * @param detalle 
 */
const getDetalle = (detalle:string) => {
    let finalDetalle = JSON.parse(detalle)
    let messageFinal = `Latencia: ${finalDetalle.latencia}`;

    return messageFinal
}


/**************************************
****** ACTIVAR/DESACTIVAR SCROLL ******
**************************************/

// Se colocó un elemento delante del gráfico para que cuando se pase el mouse por encima, se evite
// hacer el scroll dentro del gráfico, con el fin de evitar inconvenientes para el usuario final

// variable de la activación/desactivación
const isactive = ref(false);

/**
 * Desactiva el scroll dentro de gráfico
 */
const onClickOutside = () => {
    isactive.value = false;
    classHiddenScroll.value = 'hiddenScroll timelineAlertCard'
}

/**
 * Activa el scroll dentro del gráfico
 */
const isactiveClick = () =>{
    isactive.value = true;
    classHiddenScroll.value = 'showScroll timelineAlertCardSelected';
}

/**
 * Se coloca el scroll en la parte derecha cuando seleccionemos el componente
 */
const classHiddenScroll = ref('hiddenScroll timelineAlertCard')
</script>

<style>

.timelineStyles{
    border: 1px solid rgba(var(--v-theme-colorText),0.1);
    border-radius: 10px;
}

.timelineAlertCard:hover{
    border: 1.5px solid rgba(var(--v-theme-colorText),0.3);
}

.timelineAlertCardSelected{
    border: 2px solid rgba(var(--v-theme-colorText),0.7);
}

.showScroll{
    overflow: auto;
}

.hiddenScroll{
    overflow: hidden;
}
 
::-webkit-scrollbar{
    width: 10px;
    background-color: rgba(var(--v-theme-background)) !important;
}

::-webkit-scrollbar-corner{
    background-color: rgba(var(--v-theme-background)) !important;
}

::-webkit-scrollbar-thumb {
    background: rgba(var(--v-theme-colorText),.5); 
    border-radius: 10px; 
    visibility: visible;
    box-sizing: border-box;
    width: 5px; /* No necesario, pero aclarativo */
    border: 2.5px solid transparent; /* (10 - 5)/2 = 2.5px de espacio transparente */
    background-clip: content-box;
    transition: all 0.3s ease;
}
::-webkit-scrollbar-thumb:hover {
    border: 0px solid transparent; /* Sin espacio, ocupa los 10px */
    background-clip: padding-box;
}

.timelineStyles::-webkit-scrollbar{
    width: 5px;
}

.timelineStyles::-webkit-scrollbar-thumb {
    background: rgba(255,255,255,.2);
    border-radius: 10px; 
    visibility: hidden;
} 
.timelineStyles:hover::-webkit-scrollbar-thumb {
    background: rgba(255,255,255,.2);
    border-radius: 10px; 
    visibility: visible;
} 
/* .timelineStyles::-webkit-scrollbar:hover {
     width: 10px;
}  */

.v-timeline-item__opposite{
    padding: 0 !important;
}

</style>